import React from "react";
import {
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend,
} from "recharts";

function SMWeeklyTrend({ data, loading, error }) {
  const series = Array.isArray(data?.data) ? data.data : [];

  const chartData = series.map((w) => ({
    week: String(w.weekStart || "").slice(5, 10),
    leads: w.leadsCreated,
    completed: w.completed,
    won: w.won,
  }));

  return (
    <div className="dashboard-card-v2">
      <div className="dashboard-card-v2-header">
        <i className="fas fa-chart-line" />
        <span>Weekly Activity</span>
        <span className="dashboard-card-v2-count">Last {data?.windowWeeks || 4} weeks</span>
      </div>
      <div className="dashboard-card-v2-body">
        {error ? (
          <div className="dashboard-error">
            <i className="fas fa-exclamation-circle" /> {error}
          </div>
        ) : loading ? (
          <div className="dashboard-skeleton-block" style={{ height: 220 }} />
        ) : chartData.length === 0 ? (
          <div className="dashboard-empty">
            <i className="fas fa-chart-line" />
            <p>No trend data yet.</p>
          </div>
        ) : (
          <div style={{ width: "100%", height: 220 }}>
            <ResponsiveContainer>
              <LineChart data={chartData} margin={{ top: 12, right: 16, left: 0, bottom: 0 }}>
                <XAxis dataKey="week" tick={{ fontSize: 10 }} interval="preserveStartEnd" />
                <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
                <Tooltip />
               <Legend wrapperStyle={{ fontSize: 10 }} iconSize={10} />
                <Line type="monotone" dataKey="leads" stroke="#48A0DC" strokeWidth={2} name="Leads Created" />
                <Line type="monotone" dataKey="completed" stroke="#10B981" strokeWidth={2} name="Next Contacts Completed" />
                <Line type="monotone" dataKey="won" stroke="#F59E0B" strokeWidth={2} name="Won" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </div>
  );
}

export default SMWeeklyTrend;